import axiosInstance from "api/axiosConfig"
import { ENDPOINTS } from "api/endpoints"
import handleApiError from "api/utils/handleApiError"

interface BugReportData {
  email: string;
  name: string;
  url: string;
  message: string;
}

const useBugReportService = () => {
    return {
        submitBugReport: async (data: BugReportData) => {
            try{
                const response = await axiosInstance.post(ENDPOINTS.BUG_REPORT.SUBMIT_BUG_REPORT, data)

                if (!response.data) {
                    throw new Error()
                  }
            
                  return response.data
            } catch (error) {
                handleApiError('Failed to submit bug report', error)
            }
        }
    }
 }

 export default useBugReportService
